import { Species } from '../../api/fishrules/getAllSpeciesAtLocation';

export interface FormattedSpecies {
  name: string;
  bagLimit: number;
  prohibited: number;
  fishRulesId: number;
  fishbrainIds: string[];
  aggregateName: string | null;
}

export const formatAllSpeciesData = (allSpeciesData: Species[]): FormattedSpecies[] => {
  return allSpeciesData.map(r => ({
    name: r.species,
    bagLimit: r.bag_limit,
    prohibited: r.prohibited,
    fishRulesId: r.fish_id,
    fishbrainIds: r.fishbrain_ids,
    aggregateName: r.aggregate_name,
  }));
};
